import { Typography } from '@mui/material';

const UsageReport = () => (
  <div className="mt-4">
    <Typography variant="h4" sx={{ color: 'black', fontWeight: '600' }}>
      Usage Report
    </Typography>
  </div>
);

export default UsageReport;
